document.addEventListener("DOMContentLoaded", function () {
  const snowContainer = document.createElement("div");
  snowContainer.setAttribute("class", "snow-container");
  document.body.appendChild(snowContainer);

  const snowChars = ['❄','❅','❆','✻','✽'];
  const colors = ["#C41E3A", "#8FBF0A"]; // Red + Green

  for (let i = 0; i < 50; i++) {  // Reduced flow (was 80)
    const snowflake = document.createElement("div");
    snowflake.classList.add("snowflake");

    // Random position
    snowflake.style.left = Math.random() * window.innerWidth + "px";

    // Much slower fall (8–14s instead of 2–7s)
    snowflake.style.animationDuration = 8 + Math.random() * 6 + "s";

    snowflake.style.opacity = 0.7 + Math.random() * 0.6;
    snowflake.style.fontSize = 14 + Math.random() * 20 + "px";

    // Random symbol + random color
    snowflake.innerHTML = snowChars[Math.floor(Math.random() * snowChars.length)];
    snowflake.style.color = colors[Math.floor(Math.random() * colors.length)];

    // OPTIONAL: keep snowflake at bottom for 1–2s then remove
    // snowflake.style.animationFillMode = "forwards";
    // setTimeout(() => snowflake.remove(), parseFloat(snowflake.style.animationDuration) * 1000 + 1500);

    snowContainer.appendChild(snowflake);
  }
});
